$(document).ready(function(){
    $(document).on("click",".block__synergistic-solutions-body-wellness-tabs-heading,.block__synergistic-solutions-body-wellness-tabs-accordian",function(){
        $(".block__synergistic-solutions-body-wellness-tabs").removeClass('active');
        $(this).parents(".block__synergistic-solutions-body-wellness-tabs").addClass('active');
        if($(".block__synergistic-solutions-body-wellness-tabs.active").length){
            $(".block__synergistic-solutions-body-wellness-tabs-box").addClass("tab_active");
        }else{
            $(".block__synergistic-solutions-body-wellness-tabs-box").removeClass("tab_active");
        }
    });
    $(document).on("click",".block__synergistic-solutions-body-wellness-tab-close",function(){
        $(".block__synergistic-solutions-body-wellness-tabs").removeClass('active');
        $(".block__synergistic-solutions-body-wellness-tabs-box").removeClass("tab_active");
    });

    $(document).on("click",".block__synergistic-solutions-prev",function(){
        $(this).parents(".block__synergistic-solutions-body-wellness-tabs").prev().find(".block__synergistic-solutions-body-wellness-tabs-heading").trigger("click");
    });
    $(document).on("click",".block__synergistic-solutions-next",function(){
        $(this).parents(".block__synergistic-solutions-body-wellness-tabs").next().find(".block__synergistic-solutions-body-wellness-tabs-heading").trigger("click");
    });

    $(document).on("click",".block__synergistic-solutions-last-index",function(){
        $(".block__synergistic-solutions-body-wellness-tabs:last-child").find(".block__synergistic-solutions-body-wellness-tabs-heading").trigger("click");
    });
    $(document).on("click",".block__synergistic-solutions-first-index",function(){
        $(".block__synergistic-solutions-body-wellness-tabs:first-child").find(".block__synergistic-solutions-body-wellness-tabs-heading").trigger("click");
    });
});